import { HttpErrorResponse, type HttpInterceptorFn, type HttpRequest } from "@angular/common/http";
import { Observable, catchError, filter, retry, switchMap, take, throwError, timer } from "rxjs";
import { inject } from "@angular/core";
import { ApiRoutes } from "../models/constants/api-routes";
import { environment } from "../../environments/environment";
import { AuthStore } from "../stores/auth.store";

export const httpInterceptor: HttpInterceptorFn = (req, next) => {
    const authStore: AuthStore = inject(AuthStore);

    if (
        req.url.startsWith(environment.apiUrl) ||
        req.url.startsWith(environment.identityUrl) ||
        req.url.startsWith(environment.userApiUrl)) {
        const newRequest: HttpRequest<unknown> = req.clone({
            withCredentials: true,
            headers: req.headers
                .set('Access-Control-Allow-Origin', environment.boUrl)
                .set('Access-Control-Allow-Methods', 'GET, PUT, POST, OPTIONS')
                .set('Access-Control-Allow-Headers', 'Origin, Content-Type, Accept')
        });

        // This fixes Content-Type header value for specific requests.
        // TODO: Find a better way to do that.
        if (!req.url.endsWith('offersManagement/offers')) {
            newRequest.headers.set('Content-Type', 'application/json')
        }

        return next(newRequest).pipe(
            retry({ delay: shouldRetry }),
            catchError((error: HttpErrorResponse) => {
                if (error.status === 401) {
                    if (
                        !newRequest.url.includes(ApiRoutes.auth.signIn) &&
                        !newRequest.url.includes(ApiRoutes.auth.refresh)
                    ) {
                        if (!authStore.isRefreshInProgress()) {
                            authStore.isRefreshCompleted().next(false);

                            return authStore.refreshToken().pipe(
                                switchMap(() => {
                                    authStore.isRefreshCompleted().next(true);

                                    return next(newRequest);
                                }),
                            );
                        } else {
                            return authStore.isRefreshCompleted().pipe(
                                filter((x) => x),
                                take(1),
                                switchMap(() => {
                                    return next(newRequest);
                                }),
                            );
                        }
                    } else {
                        authStore.setAuthStatus(false);

                        return throwError(() => error);
                    }
                } else {
                    return throwError(() => error);
                }
            }),
        );
    }

    return next(req);
};

function shouldRetry(error: HttpErrorResponse): Observable<0> {
    if (error.status === 0) {
        return timer(2000);
    }

    throw error;
}
